<i18n src="../../locales/lang.json"></i18n>
<template>
  <div>
    <modal-empty ref="thisModal" size="modal-xs" v-bind:title="$t('add_scheduling')">
      <div style="max-height:calc(100vh - 270px);overflow-y:auto">
        <div class="m-0 p-0">
          <add-schedule-selector @event-add-procedureSch="onSave" openInPopup="true" ref="createScheduleControl"></add-schedule-selector>
        </div>
      </div>
    </modal-empty>
  </div>

</template>

<script>

  import ModalDefault from "../modals/modal-empty.vue";
  import CreateSchedule from '../Scheduling/add-schedule-selector.vue'
  export default {
    name: "procedure-schedule",
    components: {
      ModalDefault,
      CreateSchedule
    },
    props: {

    },
    data() {
      return {
        procedureId: -1,
      };
    },
    methods: {
      open(procedureId) {
        this.procedureId = procedureId;
        this.$refs.createScheduleControl.procedureId = this.procedureId;
        this.$refs.thisModal.open();
        vm.$root.$emit('nux', this.$t('nux_procedure_assign'));
        //this.$refs.createScheduleControl.selectProcedue(this.procedureId);
        this.$refs.createScheduleControl.fetchReloadData();
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      onSave() {
        this.$refs.thisModal.close();
      },
      init() {



      }
    },
    computed: {

    },
    watch: {

    },
    mounted() {

    },
    created() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>



// WEBPACK FOOTER //
// src/components/procedure/procedure-schedule.vue